import {FormField} from 'platform/components';
import {z} from 'zod';

import {useBulkUserOptions} from '@dms/api/core';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {BulkOperationForm, type BulkOperationActionCallbackParams} from 'features/eag-grid';

const TaskReassignBulkFormSchema = z.object({ownerUserId: z.string().uuid()});

export function TaskReassignBulkForm(props: {action: BulkOperationActionCallbackParams}) {
  const {loadOptions, loadLabels} = useBulkUserOptions(handleApiError);
  return (
    <BulkOperationForm
      action={props.action}
      onError={handleApiError}
      experimentalZodSchema={TaskReassignBulkFormSchema}
      defaultValues={{ownerUserId: ''}}
      toParams={(values) => values}
    >
      {(control) => (
        <FormField
          type="asyncChoice"
          control={control}
          name="ownerUserId"
          label={i18n.t('general.labels.participation.type.owner')}
          loadOptions={loadOptions}
          loadLabels={(value) => loadLabels([value.toString()])}
          menuInPortal
          isRequired
        />
      )}
    </BulkOperationForm>
  );
}
